import React from 'react';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { DesktopTimePicker } from '../../DatePicker';

const TimeInput = ({
  control,
  measurementType,
  measurementControllerName = '',
}) => (
  <div>
    <div className="w-full">
      <Controller
        control={control}
        name={`${measurementControllerName}.date_value`}
        defaultValue={dayjs().format('HH:mm')}
        render={({ field }) => (
          <DesktopTimePicker
            label={measurementType?.label}
            setValue={field.onChange}
            value={field.value}
          />
        )}
      />
    </div>
  </div>
);

TimeInput.propTypes = {
  control: PropTypes.object,
  measurementType: PropTypes.object,
  measurementControllerName: PropTypes.string,
};

export default TimeInput;
